import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Физика. 10 класс",
        subject: "Методические особенности изучения раздела «Кинематика» с использованием цифровой лаборатории",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Методические особенности изучения раздела «Кинематика» с использованием цифровой лаборатории",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Пчёлкина М.А.",
                grade: "научный сотрудник",
                subGrade: " ",
                imageSrc: "./images/author_1.png"
            },
            {
                author: "Никифоров Г.Г.",
                grade: "к.пед.н.",
                subGrade: " ",
                imageSrc: "./images/author_2.png"
            },
            {
                author: "Андреева Н.В.",
                grade: "почётный работник ОО РФ",
                subGrade: " ",
                imageSrc: "./images/author_3.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem; padding-bottom: 0'><p> Необходимость использования современного цифрового оборудования при обучении физике обусловлено сразу несколькими причинами:</p>" +
                                "<ul>" +
                                "<li>формирование функциональной грамотности обучающихся, включающее развитие компетенций в области использования ИКТ, – прямое требование обновленных ФГОС; </li>" +
                                "<li>современная физическая наука перешла к информатизации экспериментальных исследований, и в соответствии с принципом научности учебный физический эксперимент стремится к использованию адекватных современной науке методов;</li>" +
                                "<li>компьютерные технологии открывают новые возможности в обучении физике, организации учебной деятельности.</li>" +
                                "</ul></div>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Вместе с тем, очевидно, что внедрение в учебный процесс компьютерных технологий требует соответствующего методического обеспечения, разработка которого всё ещё остаётся актуальной задачей. Пока не существует разработанной методической системы учебного физического эксперимента на базе современного цифрового оборудования, и учителя могут испытывать трудности с его применением. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В настоящем методическом кейсе будет показано, как организовать исследовательскую деятельность учеников при изучении раздела «Кинематика» в 10 классе с использованием современного цифрового оборудования – цифровых лабораторий (ЦЛ). </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Будет предложена методика проведения комплексного экспериментального исследования прямолинейного равноускоренного движения тел с опорой на исторические опыты Г. Галилея на основе цикла научного познания. Подробно описана технология проведения ряда экспериментов по исследованию количественных характеристик равноускоренного движения и свободного падения тел с использованием ЦЛ. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Учитель сможет увидеть, что такое ЦЛ, познакомиться с принципом её действия: соединение традиционного оборудования с цифровыми датчиками, передающими сигнал на компьютер для последующей обработки цифровыми средствами. Убедиться, что ЦЛ не только не отменяет работу с традиционным аналоговым оборудованием, формирующим у ребят умения экспериментальной деятельности, но существенно расширяет эти возможности – позволяет обучающимся осваивать современные способы получения, обработки и представления информации, формирует компьютерную грамотность.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Мы покажем, как использование цифрового оборудования даёт возможность на уроке «протянуть нить» между историческими опытами Галилея и современными исследовательскими методами, создать условия для осознания ценности научного поиска.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В кейсе будет показано:</p>" +
                                "<ul>" +
                                "<li>как устроена цифровая лаборатория и как она работает;</li>" +
                                "<li>как организовать комплексное исследование количественных характеристик прямолинейного равноускоренного движения и свободного падения тел с опорой на исторические эксперименты и проверкой исторических гипотез (~t, s ~t<sup>2</sup>);</li>" +
                                "<li>как провести экспериментальное исследование зависимости скорости от времени и пути от времени при прямолинейном равноускоренном движении с использованием ЦЛ;</li>" +
                                "<li>как измерить ускорение свободного падения с использованием ЦЛ;</li>" +
                                "<li>как организовать экспериментальное исследование прямолинейного равнозамедленного движения тела.</li>" +
                                "</ul>"
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 1",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video1.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">Цифровая лаборатория – современное цифровое оборудование, использование которого на уроках физики выводит исследовательскую деятельность обучающихся, учебный физический эксперимент на принципиально новый уровень. </p>
                    <p style="text-indent: 2vw;">При проведении экспериментальных исследований традиционное оборудование стыкуется с цифровыми датчиками, сигнал с которых поступает на компьютер и обрабатывается соответствующими программами.</p>
                    <p style="text-indent: 2vw;">При этом не только повышается точность измерений. Принципиально новые возможности – использование цифровых секундомера, вольтметра, осциллографа, видеокамеры, покадровая обработка видео, временная развёртка значений измеряемой величины, компьютерный подбор коэффициентов для интерпретации зависимостей – позволяют знакомить учеников с методами получения и обработки информации, близкими к используемым физической наукой. </p>
                    <p style="text-indent: 2vw;">Работа с лабораторией – мы используем, в частности, ЦЛ по физике «Научные развлечения» – повышает компьютерную грамотность школьников. А осуществляемое компьютерной программой представление полученных данных – заполнение таблиц и построение графиков – существенно экономит время проведения исследования.</p>
                    <p style="text-align: center"><img src="images/cont.png"></p>
                
                
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации. Часть 2",
            imagePath: "",
            id: "2",
            videoUrl: "./video/video2.mp4",
            contentBefore: [{
                type: "text",
                text: `
                    <p style="text-indent: 2vw;">Кинематика – один из наиболее формализованных разделов физики, задачи которого решаются в основном математическими средствами. Организация экспериментальных исследований при изучении этого раздела довольно сложна. </p>
                    <p style="text-indent: 2vw;">Использование цифровых лабораторий делает возможным исследование равноускоренного, равнозамедленного движения и свободного падения тел через совместный с учителем и самостоятельные эксперименты обучающихся.</p>
                    
                `
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 5,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Галилей Г. Избранные труды. В 2 т. / предисл. акад. А. Ю. Ишлинского. — Москва: Наука, 1964",
                "Голин Г. М., Филонович С. Р. Классики физической науки (с древнейших времен до начала XX в.): справ. пособие. — Москва: Высш. шк., 1989",
                "Использование новых компьютерных инструментов при изучении механики / С. И. Сергеев [и др.] // Физика в школе. 2008,  № 7",
                "Наука. Величайшие теории: 9: Природа описывается формулами. Галилей. Научный метод / пер. с итал. — Москва: Де Агостини, 2015",
                "Никифоров Г. Г. «Компьютерный эксперимент» в курсе физики средней школы: будем осторожны // Физика в школе. 2008,  № 7 ",
                "Разумовский В. Г., Майер В. В. Физика в школе. Научный метод познания и обучение. — Москва: Гуманитар. изд. центр ВЛАДОС, 2004",
                "Сивухин Д. В. Общий курс физики: учеб. пособие для вузов. В 5 т. – 4-е изд. — Москва: Физматлит; МФТИ, 2005. Т. 1: Механика",
                "Ступникова М. Ф. Компьютерный образовательный комплекс // Физика в школе. 2008,           № 7",
                "Цифровые лаборатории. Методическое руководство по работе с комплектом оборудования и программным обеспечением фирмы «Научные развлечения» / А. Н. Болгар, Н. К. Ханнанов. — Москва: «Научные развлечения», 2011",
                "Криз Р. Призма и маятник. Десять самых красивых экспериментов в истории науки [Электронный ресурс] // Викичтение: электронная библиотека. URL: https://tech.wikireading.ru/hY7SKuoMxF (дата обращения: 21.05.2023).",
            ],
            sites: [],
            filesToDownload: [
                {link: "./files/material1.pdf", fileName: "Исследование неравномерного движения с помощью цифровой лаборатории"},
                {link: "./files/material2.pdf", fileName: "Исследование равномерного движения с помощью цифровой лаборатории"},
            ]
        }
    ],
};
